import { defineMessages } from 'react-intl';

export const featuresMessages = defineMessages({
  loyaltyEarnByPurchase: {
    id: 'checkout.features.loyalty.loyaltyEarnByPurchase',
    defaultMessage: 'You will earn <b> {points} points </b> from this purchase!',
  },

  loyaltyEnrollInto: {
    id: 'checkout.features.loyalty.loyaltyEnrollInto',
    defaultMessage:
      '<b>Don’t miss out on rewards! </b> Enroll into Loyalty program and earning <b> {points} points </b> & special rewards.',
  },

  loyaltyRewardLabel: {
    id: 'checkout.features.loyalty.loyaltyRewardLabel',
    defaultMessage: 'Loyalty Reward',
    description: 'Label for product which is from loyalty rewards',
  },
});
